import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useSectionRefs } from "../../../hooks/useSectionRefs";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { Link } from "react-router-dom";

const HelpTopicPolitiqueConfidentialite = () => {
  const { auth, setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);
  const isSmallDevise = windowWidth < 900;  
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Conditions juridiques', link: '/topics/about/juridiques'},
    { label: topic.title, link: topic.link},
  ]
  
  
  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-12 w-help-title'
      />
      <p className="help-text fz-16 fw-500 mt-8 op-7 mb-24">Dernière mise à jour : 24 Juin 2026</p>
      <div className="help-content-container mt-0">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              La politique de confidentialité de Wodzone explique vos droits relatifs à la protection de la vie privée, les données personnelles collectées, ainsi que leur utilisation et leur partage.
            </p>
            <p className="help-text">
              Wodzone vise à rendre vos expériences de compétitions inoubliables. En d'autres termes, nous souhaitons créer un esapace simple à utiliser, intuitif et performant. Nous sommes une communauté de sportif fondée sur la confiance, et pour l'établir, il est essentiel de garantir la transparence sur l'utilisation de vos informations et la protection de votre vie privée.
            </p>
            <p className="help-text">
              Cette politique de confidentialité explique comment Wodzone («&nbsp;<strong>nous</strong>&nbsp;», «&nbsp;<strong>nos/notre</strong>&nbsp;» ou «&nbsp;<strong>Wodzone</strong>&nbsp;») gèrent vos données personnelles lorsque vous utilisez la plateforme Wodzone.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <section className="mt-24 scroll-mt-80" id="recherche-inscription">
                <p className="help-title-part">{topic.subtitles[0]}</p>
                <p className="help-title-part fz-16 mb-8">1.1 Responsable du traitement</p>
                <p className="help-text">
                  Dans cette politique, les termes « <strong>Wodzone</strong> », « <strong>nous</strong> », « <strong>notre</strong> » ou « <strong>nos</strong> » désignent l’entité Wodzone chargée de gérer vos informations conformément aux règles de confidentialité en vigueur. L’organisme responsable du traitement des données est précisé en Annexe 1.
                </p>
                <p className="help-title-part fz-16 mb-8 mt-24">1.2 Responsable du traitement des paiements</p>
                <p className="help-text">
                  Cette politique de confidentialité s'applique également aux services de paiement proposés par Wodzone et Stripe, conformément aux Conditions de paiement. En utilisant ces services, vous transmettez certaines données personnelles à une ou plusieurs entités de Wodzone et Stripe (désignées comme « Responsable du traitement des paiements » dans l'Annexe 1), qui gèrent vos informations en lien avec les paiements, en fonction de votre pays de résidence.
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <section className="mt-24 scroll-mt-80" id="info-necessaires">
                <p className="help-title-part">{topic.subtitles[1]}</p>
                <p className="help-title-part fz-16 mb-8">2.1 Informations nécessaires pour utiliser la Plateforme Wodzone</p>
                <p className="help-text">
                  Lorsque vous accédez à la plateforme Wodzone, nous recueillons des informations personnelles nécessaires à la mise à disposition de nos services. Sans ces données, nous ne serions pas en mesure de répondre à vos besoins. Voici les types d’informations concernées :
                </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Coordonnées, compte et informations du profil : </strong>
                      Votre prénom, nom de famille, adresse e-mail, genre, date de naissance, votre box, .
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations relatives à l'identité</strong> : 
                      Le cas échéant, notament pour la création de votre compte de versement via Stripe, nous pouvons vous demander de fournir une photo de votre pièce d'identité. 
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations sur les transactions de paiement</strong> : 
                      Il peut s'agir du compte de paiement, des informations de carte de crédit, des informations de compte bancaire, du mode de paiement utilisé, de la date et de l'heure, du montant du paiement, de la date d'expiration du mode de paiement et du code postal de facturation, de l'adresse e-mail, des informations IBAN, de votre adresse et d'autres informations de transaction associées.
                    </p>
                  </li>
                </ul>
                <p className="help-title-part fz-16 mb-8 mt-32">2.2 Informations que vous choisissez de nous fournir</p>
                <p className="help-text">
                  Vous pouvez choisir de nous fournir des données personnelles supplémentaires, notamment&nbsp;:
                </p>
                <ul className="pl-20 mt-8">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations de profil supplémentaires : </strong>
                      Il peut s'agir de votre numéro de téléphone, photo de profil, vos tailles sport-wears et de toute information de profil supplémentaire que vous fournissez.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations relatives aux communications : </strong>
                      Il peut s'agir d'un e-mail, d'un SMS lorsque la livraison est activée sur ou par l'intermédiaire de la Plateforme Wodzone.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations relatives à l'assistance : </strong>
                      Il peut s'agir d'enregistrements, conformément aux exigences du droit applicable, d'informations de chat et de messages collectés pour fournir des services d'assistance utilisateurs, notamment pour enquêter et répondre aux préoccupations des utilisateurs, ainsi que pour vérifier et améliorer nos processus d'assistance.
                    </p>
                  </li>
                </ul>
                <p className="help-title-part fz-16 mb-8 mt-32">2.3 Informations collectées automatiquement lors de l'utilisation de la Plateforme Wodzone et de nos Services de paiement</p>
                <p className="help-text">
                  Lorsque vous utilisez la Plateforme Wodzone et les Services de paiement Stripe, nous collectons automatiquement certaines informations. Ces informations peuvent inclure les éléments suivants :
                </p>
                <ul className="pl-20 mt-8">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations de géolocalisation : </strong>
                      Il peut s'agir d'une localisation précise ou approximative déterminée à partir de votre adresse IP, du GPS de votre téléphone portable ou d'un autre appareil, ou d'autres informations que vous partagez avec nous, en fonction des réglages de votre appareil. Nous pouvons également collecter ces informations lorsque vous n'utilisez pas l'application, si vous activez cette option dans vos réglages ou dans les autorisations de l'appareil.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations d'utilisation : </strong>
                      Il peut s'agir de recherches de compétitions, des réservations que vous avez faites, des dates et des heures d'accès, des actions effectuées sur la Plateforme Wodzone, y compris les pages ou le contenu que vous consultez. Nous pouvons collecter ces informations même si vous n'avez pas créé de compte Wodzone ou si vous ne vous êtes pas connecté(e).
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Informations relatives à l'appareil : </strong>
                      Il peut s'agir de l'adresse IP, d'informations sur le matériel et le logiciel, d'informations sur l'appareil, d'informations sur les événements de l'appareil, d'identifiants uniques, de données de plantage et d'accusés de réception. Nous pouvons collecter ces informations même si vous n'avez pas créé de compte Wodzone ou si vous ne vous êtes pas connecté(e).
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Cookies et technologies similaires telles que décrites dans notre
                      <a className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/cookie-policy`}>utilisation des cookies</a></strong>
                    </p>
                  </li>
                </ul>
                <p className="help-title-part fz-16 mb-8 mt-32">2.4 Informations collectées auprès de tierces parties</p>
                <p className="help-text">
                  Nous pouvons collecter des données personnelles auprès d'autres sources, notamment&nbsp;:
                </p>
                <ul className="pl-20 mt-8">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Athlètes d'une même team : </strong>
                      Si quelqu'un vous inscrit à une compétition sur la plateforme Wodzone en tant qu'athlète de la même équipe, certaines de vos données personnelles seront transmises par la personne ayant initié l'invitation.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Personnes déposant des réclamations : </strong>
                      Si un Organisateur, un Athlète ou un tiers dépose une réclamation à votre encontre, nous pouvons recevoir des informations relatives à la réclamation déposée afin de comprendre et, le cas échéant, de traiter la réclamation.
                    </p>
                  </li>
                </ul>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part">{topic.subtitles[2]}</p>
              <p className="help-title-part fz-16 mb-8">3.1 Fournir la Plateforme Wodzone</p>
              <p className="help-text mb-4">Nous pouvons traiter ces informations pour : </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">
                      Vous permettre d'accéder à la Plateforme Wodzone et d'effectuer et de recevoir des paiements
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Traiter et répondre à votre demande
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Vous fournir une assistance
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Vous envoyer des messages, des mises à jour, des alertes de sécurité et des notifications de compte
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Vous permettre d'utiliser nos produits et nos services pour participer et suivre votre compétition
                    </p>
                  </li>
                </ul>
              <p className="help-title-part fz-16 mb-8 mt-32">3.2 Améliorer et développer la Plateforme Wodzone</p>
              <p className="help-text mb-4">Nous pouvons traiter ces informations pour : </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">
                      Vous permettre d'accéder à la Plateforme Wodzone et d'effectuer et de recevoir des paiements
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Effectuer des analyses, des débogages et mener des recherches</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Améliorer et développer nos produits et services</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Proposer une formation aux équipes de l'assistance utilisateurs</p>
                  </li>
                </ul>
              <p className="help-title-part fz-16 mb-8 mt-32">3.3 Protéger la Plateforme et la Communauté Wodzone</p>
              <p className="help-text mb-4">Nous pouvons traiter ces informations pour : </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">Détecter, prévenir, évaluer et traiter la fraude et les risques de sécurité</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Protéger la communauté contre les activités ou autres comportements illégaux, comme indiqué sur la
                      <Link to='#' className="link" onClick={() => window.scroll(0,0)}>page relative aux Politiques de sécurité</Link>
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Vérifier ou authentifier les informations que vous avez fournies, y compris les informations d'identité, comme décrit dans la section
                      «&nbsp;<a className="link" href={'#info-necessaires'}>Informations nécessaires pour utiliser la Plateforme Wodzone</a>&nbsp;»
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Effectuer des vérifications dans des bases de données et d'autres sources d'information</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Respecter nos obligations légales, protéger la santé et le bien-être de nos athlètes, organisateurs et membres du public,
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Résoudre les litiges avec nos Membres, y compris partager des informations avec votre ou vos co-Organisateurs ou des Athètes supplémentaires concernant les litiges liés à votre rôle de co-Organisateur ou de Athète supplémentaire,
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">faire respecter nos contrats avec des tiers</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Se conformer à la loi, répondre aux demandes légales, prévenir les dommages et protéger nos droits (voir la section 
                        «&nbsp;<a className="link" href={'#'}>Se conformer à la loi,</a>
                        <a className="link" href={'#'}>répondre aux demandes légales,</a>
                        <a className="link" href={'#'}>prévenir les dommages et protéger nos droits</a>&nbsp;»),
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Faire respecter nos<Link to='/topics/about/60' className="link" onClick={() => window.scroll(0,0)}>Conditions de service</Link> (les « <strong>Conditions</strong> ») et nos autres politiques
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Evaluer vos interactions avec la Plateforme Wodzone ainsi que les informations obtenues auprès de tierces parties.
                    </p>
                  </li>
                </ul>
              <p className="help-title-part fz-16 mb-8 mt-32">3.4 Fournir, personnaliser, évaluer et améliorer nos activités publicitaires et marketing</p>
              <p className="help-text mb-4">Nous pouvons traiter ces informations pour : </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">Vous envoyer des messages promotionnels, publicitaires et marketing, et d'autres informations</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Afficher, personnaliser, évaluer et améliorer nos publicités sur des plateformes publicitaires</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Gérer les récompenses, programmes de parrainage, enquêtes, loteries, concours, ou autres activités ou événements promotionnels organisés ou gérés par Wodzone ou ses partenaires commerciaux
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Vous inviter à des événements ou autres occasions</p>
                  </li>
                </ul>
              <p className="help-title-part fz-16 mb-8 mt-32">3.5 Fournir des Services de paiement</p>
                <p className="help-text mb-8">
                  Les données personnelles sont utilisées pour permettre ou autoriser des tiers à utiliser les Services de paiement (tels que Stripe), notamment pour :
                </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">Traiter les paiements</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Exécuter le contrat avec vous</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Vérifier votre identité</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Détecter et prévenir le blanchiment d'argent, la fraude, les abus et les incidents de sécurité</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Mener des enquêtes de sécurité et des évaluations du risque</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Se conformer aux obligations légales et de conformité applicables (telles que les réglementations pour la lutte contre le blanchiment d'argent et l'application des sanctions)</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Se conformer aux obligations légales et de conformité applicables (telles que les réglementations pour la lutte contre le blanchiment d'argent et l'application des sanctions)</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Appliquer les<Link to='#' className="link" onClick={() => window.scroll(0,0)}>Conditions de paiement</Link>et autres politiques de paiement
                    </p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">
                      Fournir et améliorer les services de paiement
                    </p>
                  </li>
                </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[3].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[3]}</p>
                <p className="help-title-part fz-16 mb-8">4.1 Transmission avec votre consentement ou selon vos instructions</p>
                <p className="help-text">
                  Lorsque vous donnez votre consentement ou nous demandez de transmettre vos informations, nous transmettons vos informations telles que décrites au moment du consentement ou du choix, par exemple lorsque vous autorisez une application ou un site web tiers à accéder à votre compte Wodzone ou participez à des activités promotionnelles émises par des partenaires de Wodzone ou des tiers.
                </p>
                <p className="help-title-part fz-16 mb-8 mt-24">4.2 À qui nous transmettons</p>
                <p className="help-text">Nous pouvons transmettre vos informations aux entités suivantes :</p>
                <ul className="pl-20 mt-0">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Autres membres : </strong>
                      Pour faciliter les inscriptions aux compétitions, nous pouvons transmettre des informations tels que votre prénom, nom, photo de profil, votre genre, votre date de naissance, ou encore vos tailles sport-wear. <br/><strong>A noter : Nous ne communiquerons pas votre adresse e-mail ni votre numéro de téléphone. Seulement en cas de necessité absolue.</strong>
                    </p>
                  </li>
                  <li className="mb-24">
                    <p className="help-text">
                      <strong>Liste des athlètes Wodzone : </strong>
                      En créant votre compte Wodzone, vous acceptez d'apparaître dans une liste déroulante destinée à faciliter la composition d'équipes et l'inscription aux compétitions. Cette fonctionnalité permet de pré-remplir automatiquement de nombreux champs lors des inscriptions, simplifiant ainsi le processus pour vous et les autres athlètes.
                    </p>
                    <p className="help-text mt-12">
                      <strong>Informations visibles :</strong> Votre nom, prénom, votre box d'affiliation et votre photo de profil (si ajoutée).
                    </p>
                    <p className="help-text mt-8">
                      <strong>Informations utilisées mais non affichées :</strong> Vos tailles sport-wear (si renseignées) sont utilisées uniquement pour pré-remplir les formulaires sans être visibles dans la liste.
                    </p>
                    <p className="help-text mt-12 mb-8">
                      <strong>--{'>'} Gestion de votre visibilité :</strong> Vous pouvez à tout moment modifier ces paramètres depuis votre compte
                      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/confidentialite`}>Confidentialité et visibilité</a>pour :
                    </p>
                    <ul className="pl-20 mt-4">
                      <li className="mb-4">
                        <p className="help-text">Ne plus apparaître dans la liste des athlètes</p>
                      </li>
                      <li className="mb-4">
                        <p className="help-text">Limiter votre visibilité uniquement aux membres des box que vous avez sélectionnées</p>
                      </li>
                    </ul>
                  </li>
                  <li className="mb-24">
                    <p className="help-text">
                      <strong>Fonctionnalité de blocage d'athlètes (WodMatch) : </strong>
                      WodMatch te permet de bloquer des athlètes pour qu'ils ne voient pas ton profil, et que tu ne voies pas le leur.
                    </p>
                    <p className="help-text mt-12">
                      <strong>Informations affichées dans la recherche :</strong> Uniquement le prénom et la box d'affiliation des athlètes visibles dans la liste de diffusion.
                    </p>
                    <p className="help-text mt-8">
                      <strong>Ce que nous ne divulguons pas :</strong> L'adresse e-mail, le numéro de téléphone ou toute autre donnée personnelle ne sont jamais affichés dans les résultats de recherche.
                    </p>
                    <p className="help-text mt-8">
                      <strong>Confidentialité du blocage :</strong> La personne bloquée n'est jamais notifiée du blocage.
                    </p>
                    <p className="help-text mt-12">
                      <strong>--{'>'} Gestion de votre visibilité :</strong> Seuls les athlètes ayant choisi d'apparaître dans la liste de diffusion sont accessibles via cette recherche. Vous pouvez modifier ce paramètre à tout moment depuis{' '}
                      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/confidentialite`}>
                        Confidentialité et visibilité
                      </a>.
                    </p>
                  </li>
                  <li className="mb-32">
                    <p className="help-text">
                      <strong>Volontaires et organisateurs : </strong>
                      Lorsque vous vous inscrivez en tant que bénévole pour une compétition, vous acceptez que vos coordonnées 
                      (adresse e-mail a minima, et numéro de téléphone si communiqué) soient transmises à l'organisateur de l'événement. 
                      Cette transmission est nécessaire pour permettre les échanges concernant les missions, les modalités et l'organisation de la compétition.
                    </p>
                    <p className="help-text mb-8 mt-12">
                      <strong>Protection de vos données :</strong> L'organisateur s'engage, conformément au RGPD et à la charte signée avec Wodzone, à :
                    </p>
                    <ul className="pl-20 mt-0 mb-12">
                      <li className="mb-4">
                        <p className="help-text">Conserver vos données uniquement pour la durée nécessaire jusqu'à la fin de l'événement</p>
                      </li>
                      <li className="mb-4">
                        <p className="help-text">Utiliser vos informations exclusivement dans le cadre de l'organisation de la compétition</p>
                      </li>
                    </ul>
                    <p className="help-text mt-8">
                      <strong>--{'>'} Gestion de votre confidentialité :</strong> Si vous ne souhaitez pas divulguer vos informations personnelles aux organisateurs, vous pouvez modifier vos paramètres de confidentialité à tout moment depuis votre compte
                      <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/compte/confidentialite`}> Confidentialité et visibilité</a>.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Prestataires de services : </strong>
                      Nous transmettons des données personnelles à des prestataires de services affiliés et non affiliés (tel que Stripe par exemple pour la gestion des paiements) pour nous aider à gérer nos activités et à des fins de conformité, y compris celles qui nous aident à : (i) vérifier votre identité ou authentifier vos documents d'identité (ii) effectuer le développement, la maintenance et le débogage des produits, (iii) fournir une assistance utilisateurs, de la publicité ou des services de paiement. Ces fournisseurs sont contractuellement tenus de protéger vos données personnelles, y ont accès pour effectuer ces tâches et peuvent également divulguer vos informations lorsque la loi l'exige.
                    </p>
                  </li>
                </ul>
                <p className="help-title-part fz-16 mb-8 mt-32">4.3 Pourquoi nous pouvons transmettre vos informations</p>
                <p className="help-text">Nous pouvons transmettre vos informations afin de :</p>
                <ul className="pl-20 mt-0">
                  <li className="mb-16">
                    <p className="help-text">
                      <strong>Créer votre profil public : </strong>
                      Les informations que vous partagez publiquement sur la Plateforme Wodzone peuvent être indexées par le biais de moteurs de recherche tiers. Nous pouvons rendre certaines informations publiquement visibles par les autres utilisateurs, telles que votre prénom, nom, photo de profil, votre genre, votre date de naissance, ou encore vos tailles sport-wear.
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      Se conformer à la loi, répondre aux demandes légales, prévenir les dommages et protéger nos droits
                    </p>
                  </li>
                </ul>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[4].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[4]}</p>
                <p className="help-title-part fz-16 mb-8">Conditions des services tiers</p>
                <p className="help-text">
                  Certaines parties de Wodzone peuvent être liées à des services tiers. Wodzone ne possède ni ne contrôle ces tierces parties. Lorsque vous interagissez avec ces tierces parties et choisissez d'utiliser leur service, vous leur fournissez des informations vous concernant. Votre utilisation de ces services est soumise aux politiques de confidentialité de ces fournisseurs, y compris les Conditions d'utilisation supplémentaires de Mapbox,
                  <a target='_blank' className="link" href={`https://www.mapbox.com/legal/privacy`}>la Politique de confidentialité de Mapbox,</a>
                  la<a target='_blank' className="link" href={`https://www.mailgun.com/fr/legal/politique-confidentialite/`}>la Politique de confidentialité de Mailgun,</a>
                  et la<a target='_blank' className="link" href={`https://stripe.com/fr/privacy`}>Politique de confidentialité de Stripe.</a>
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[5].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[5]}</p>
                <p className="help-text">
                  Vous pouvez exercer l'un des droits décrits dans le présent article conformément au droit applicable. Consultez
                  <Link to='#' className="link" onClick={() => window.scroll(0,0)}>cette page</Link>pour obtenir des informations sur les demandes de droits de la personne concernée et sur la manière d'envoyer une demande.
                </p>
                <p className="help-text">
                  Pour en savoir plus sur vos droits en vertu du Règlement général sur la protection des données (« RGPD »),
                  <Link to='#' className="link" onClick={() => window.scroll(0,0)}>cliquez ici.</Link>
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[6].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[6]}</p>
                <p className="help-title-part fz-16 mb-8">7.1 Périodes de conservation</p>
                <p className="help-text">
                  Nous conservons les données personnelles aussi longtemps que nécessaire ou que cela est autorisé à la lumière de la ou des finalités pour lesquelles elles ont été obtenues et conformément au droit applicable. La durée de conservation des données est déterminée en fonction des critères suivants :
                </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-16">
                    <p className="help-text">
                      La durée de notre relation et la durée pendant laquelle nous mettons à votre disposition les services de la plateforme Wodzone, que vous soyez Athlète ou Orgnisateur (par exemple, aussi longtemps que vous avez un compte chez nous ou que vous utilisez Wodzone) et la durée pendant laquelle nous pouvons avoir un besoin légitime de conserver vos données personnelles, par exemple pour gérer et protéger notre activité, pour résoudre des problèmes ou pour défendre des réclamations qui pourraient survenir
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      Si nous sommes soumis à une obligation légale, fiscale, de déclaration ou d'audit, telle que les exigences en matière de lutte contre le blanchiment d'argent, qui nous obligent à conserver les enregistrements de vos transactions pendant un certain temps avant de pouvoir les supprimer
                    </p>
                  </li>
                  <li className="mb-16">
                    <p className="help-text">
                      Si la conservation est souhaitable compte tenu de notre situation juridique ou pour protéger la sécurité des individus, ce qui comprend la conservation requise ou prudente conformément aux délais de prescription applicables, aux litiges ou aux enquêtes réglementaires
                    </p>
                  </li>
                </ul>
                <p className="help-title-part fz-16 mb-8 mt-32">7.2 Informations partagées</p>
                <p className="help-text">
                  Les informations que vous avez partagées avec d'autres Membres, peuvent continuer à être publiques sur Wodzone, même après la suppression de votre compte Wodzone. Mais vos informations n'apparaitront plus dans le menu de selection d'atlète pour composer une équipe.
                </p>
                <p className="help-title-part fz-16 mb-8 mt-32">7.3 Copies résiduelles</p>
                <p className="help-text">
                  Dans la mesure où nous protégeons les informations contre toute perte accidentelle ou malveillante et contre toute destruction, des copies résiduelles de vos données personnelles pourraient ne pas être supprimées de nos systèmes de sauvegarde pendant une période limitée.
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[7].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[7]}</p>
                <p className="help-text">
                  Bien qu'aucune organisation ne puisse garantir une sécurité parfaite, nous mettons en œuvre et faisons évoluer en permanence nos mesures de sécurité administratives, techniques et physiques pour protéger vos informations contre les accès illicites ou non autorisés, pertes, destructions ou modifications.
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[8].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[8]}</p>
                <p className="help-text">
                  Nous nous réservons le droit de modifier la présente Politique de confidentialité à tout moment conformément à la législation en vigueur. Le cas échéant, nous publierons la version révisée de la Politique de confidentialité et actualiserons la date de « Dernière mise à jour » figurant au début de celle-ci. En cas de modification importante, nous vous en informerons également par e-mail au minimum trente (30) jours avant la date d'entrée en vigueur de la nouvelle version. Si vous n'approuvez pas les nouvelles conditions de la Politique de confidentialité, nous vous invitons à supprimer votre compte. Si vous ne supprimez pas votre compte avant la date d'entrée en vigueur de la nouvelle Politique de confidentialité, votre accès et votre utilisation continus de la plateforme Wodzone seront soumis à la nouvelle Politique de confidentialité.
                </p>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[9].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[9]}</p>
                <p className="help-text">
                  Pour toute question ou réclamation concernant la présente Politique de confidentialité ou le traitement des données personnelles par Wodzone :
                </p>
                <ul className="pl-20 mt-0">
                  <li className="mb-8">
                    <p className="help-text">Wodzone, 5 Allée Jean THORTE, 47510 Foulayronnes, France</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Envoyez un e-mail à wodzone@outlook.fr</p>
                  </li>
                  <li className="mb-8">
                    <p className="help-text">Ou bien utiliser notre<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>formulaire de contact.</a></p>
                  </li>
                </ul>
              </section>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[10].ref}>
              <section className="mt-24 scroll-mt-80" id="">
                <p className="help-title-part">{topic.subtitles[10]}</p>
                <p className="help-text">
                  Les termes non définis dans la présente Politique de confidentialité ont la même définition que celle indiquée dans nos<Link to='/topics/about/60' className="link" onClick={() => window.scroll(0,0)}>Conditions.</Link>
                </p>
              </section>
            </div>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )

}

export default HelpTopicPolitiqueConfidentialite